import * as React from 'react';
import { FormSection } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';

import { Person } from '@components/person';
import Address, { AddressField } from '@components/form/Address/Address';

const View: React.SFC<any> = ({ form }) => (
  <div>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>

      <Row>
        <Col md={6} xl={6} className="with-right-divider">
          <Row>
            <Col md={12}>
              <h4>Jméno</h4>
            </Col>
          </Row>
          <FormSection name="vehicle.owner">
            <Person form={form} formName="vehicle.owner." showCompanyInputs={true} />
          </FormSection>
        </Col>
        <Col md={6} xl={6}>
          <Row>
            <Col md={12}>
              <h4>Bydliště</h4>
            </Col>
          </Row>
          <AddressField component={Address} name={'vehicle.owner.address'} />
        </Col>
      </Row>

      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
  </div>
);

export const WantedVehiclesFormOwner = View;



// WEBPACK FOOTER //
// ./src/modules/wantedVehicles/WantedVehiclesFormOwner.tsx